import { InvoicePaymentStatusEnum } from "@/constants/enums/invoicePaymentStatus.enum";
import { DisplayedInvoicePaymentStatus } from "@/hooks/useEnumLabels";

/** Couleurs du badge de statut de paiement (libellés : `useInvoicePaymentStatusOptions`). */
export const INVOICE_PAYMENT_STATUS_COLORS: Record<
  DisplayedInvoicePaymentStatus,
  { borderColor: string; bgColor: string; textColor: string }
> = {
  [InvoicePaymentStatusEnum.TOBEPAID]: {
    borderColor: "#FEDF89",
    bgColor: "#FFFAEB",
    textColor: "#B54708",
  },
  [InvoicePaymentStatusEnum.TOBECONFIRMED]: {
    borderColor: "#bfdbfe",
    bgColor: "#eff6ff",
    textColor: "#067AFF",
  },
  [InvoicePaymentStatusEnum.PROCESSING]: {
    borderColor: "#bfdbfe",
    bgColor: "#eff6ff",
    textColor: "#067AFF",
  },
  [InvoicePaymentStatusEnum.PAID]: {
    borderColor: "#ABEFC6",
    bgColor: "#ECFDF3",
    textColor: "#067647",
  },
};

export const invoiceStatus = ["PAID", "TOBEPAID", "PROCESSING"] as const;

type invoiceStatusType = (typeof invoiceStatus)[number];

export function validateInvoiceStatus(value: string): invoiceStatusType | undefined {
  if (invoiceStatus.includes(value as invoiceStatusType)) {
    return value as invoiceStatusType;
  } else {
    return undefined;
  }
}
